export default __webpack_public_path__ + "assets/images/d386536bd45e8a82136aed405b7d7d44.svg";